import React, { useCallback } from 'react'
import { confirmModal, cancelModal } from 'actions/confirm'
import selectConfirm from 'selectors/confirm'
import Button from 'components/utils/Button'
import Modal from 'components/utils/Modal'
import { useAppSelector, useAppDispatch } from 'store/hooks'

const Confirm = () => {
  const { toConfirm } = useAppSelector(selectConfirm)
  const dispatch = useAppDispatch()

  const handleClose = useCallback(() => {
    dispatch(cancelModal(0))
  }, [dispatch])

  const handleConfirm = useCallback(() => {
    dispatch(confirmModal(0))
  }, [dispatch])

  const handleKeyDown = useCallback((e: KeyboardEvent) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      e.stopPropagation()
      handleConfirm()
    }
  }, [handleConfirm])

  const isOpen = toConfirm.length > 0
  const message = toConfirm[0]?.message as React.ReactNode
  return (
    <Modal open={isOpen} onClose={handleClose} onKeyDown={handleKeyDown}>
      <div className="modal-body">{message}</div>
      <div className="modal-footer">
        <Button autoFocus onClick={handleConfirm}>
          yes
        </Button>
        <Button onClick={handleClose}>no</Button>
      </div>
    </Modal>
  )
}

export default Confirm
